import React from 'react';
import uniqueId from 'lodash/uniqueId';
var LiteratureCoverLetter = function (_a) {
    var _b;
    var title = _a.deviation.title;
    var filteredTitle = (_b = title === null || title === void 0 ? void 0 : title.replace(/[^a-zA-Z]/g, '')) !== null && _b !== void 0 ? _b : '';
    if (!filteredTitle.length) {
        return null;
    }
    var gradientId = "lit-gradient".concat(uniqueId());
    return (React.createElement("div", { className: "daeditor-literature-letter" },
        React.createElement("svg", { height: "100%", viewBox: "0 0 15 12", preserveAspectRatio: "xMidYMin slice", fillRule: "evenodd" },
            React.createElement("linearGradient", { x1: "100%", y1: "16.1729237%", x2: "100%", y2: "83.3711592%", id: gradientId },
                React.createElement("stop", { stopColor: "#00FF77", offset: "0%" }),
                React.createElement("stop", { stopColor: "#3197EF", stopOpacity: "0", offset: "100%" })),
            React.createElement("text", { className: "daeditor-literature-letter-inner", fill: "url(#".concat(gradientId, ")"), x: "15", y: "-9%", textAnchor: "end", alignmentBaseline: "hanging" }, filteredTitle[0]))));
};
LiteratureCoverLetter.displayName = 'LiteratureCoverLetter';
export default LiteratureCoverLetter;
//# sourceMappingURL=HtmlLiteratureCoverLetter.js.map